var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { ActionList, ActionListItem, ToggleButton, } from "@animech/ui";
import { useRef } from "react";
import * as Styled from "./label-with-description.style";
import { InfoButton, } from "ui/components/elements/info-button";
export var LabelWithDescription = function (_a) {
    var label = _a.label, caption = _a.caption, description = _a.description, menuActions = _a.menuActions;
    return (_jsxs(Styled.LabelWithDescription, { hasCaption: !!caption, children: [_jsxs(Styled.LabelAndOptions, { children: [_jsxs(Styled.LabelAndCaption, { children: [_jsx(Styled.Label, { children: label }), caption && _jsx(Styled.Caption, { children: caption })] }), menuActions && _jsx(MenuPanel, { actions: menuActions })] }), (description === null || description === void 0 ? void 0 : description.long) && (_jsx(InfoButton, { title: label, description: description }))] }));
};
var SelectableItem = function (_a) {
    var action = _a.action, onClick = _a.onClick;
    return (_jsx(ActionListItem, { onClick: function () { return onClick && onClick(action.value); }, color: "neutral", children: action.label }));
};
var OptionTree = function (_a) {
    var options = _a.options, onClick = _a.onClick, usePadding = _a.usePadding;
    return (_jsx(_Fragment, { children: options.map(function (option, index) { return (_jsxs(Styled.OptionGroup, { padding: !!usePadding, children: [option.disabled ? (_jsx(Styled.OptionLabel, { children: option.label })) : (_jsx(SelectableItem, { action: option, onClick: function () { return onClick(option.value); } })), option.children && (_jsx(OptionTree, { usePadding: true, options: option.children, onClick: onClick }))] }, "".concat(option.value, "-").concat(index))); }) }));
};
var MenuPanel = function (_a) {
    var actions = _a.actions;
    var wrapperRef = useRef(null);
    return (_jsx("div", { ref: wrapperRef, children: _jsx(ActionList, { toggleElement: _jsx(MenuButton, {}), placement: "bottom-start", transition: "none", children: actions.map(function (action, i) {
                return action.options ? (_jsx(ActionList, { toggleElement: _jsx("span", { children: _jsx(ActionListItem, { color: "neutral", children: action.label }, action.label + i) }), placement: "right", transition: "none", children: _jsx(Styled.ScrollableOptionList, { children: _jsx(OptionTree, { options: action.options, onClick: action.onClick }) }) }, action.label + i)) : (_jsx(SelectableItem, { action: action, onClick: function () {
                        var _a;
                        action.onClick();
                        // hack to close the menu by clicking the wrapper
                        (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    } }, action.value));
            }) }) }));
};
var MenuButton = function (props) { return (_jsx(ToggleButton, __assign({}, props, { appearance: "text", size: "small", itemIcons: ["more-vertical-fill", "more-vertical"] }))); };
